import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiUri } from "../../utilities/apiManager";

const initialState = {
  isLoading: false,
  data: [],
  itemsCount: 0,
  pages: 0,
  error: null,
};

export const getWallet = createAsyncThunk(
  "wallet/getWallet",
  async (args, thunkApi) => {
    try {
      const { page = 1, size = 10 } = args || {};
      const { data } = await axios.get(
        `${apiUri}/wallet?page=${page}&size=${size}`,
        {
          headers: {
            "auth-token": "Bearer " + thunkApi.getState().auth.accessToken,
            "Accept-Language": document.documentElement.lang,
          },
        }
      );
      return thunkApi.fulfillWithValue(data);
    } catch (e) {
      return thunkApi.rejectWithValue(e.response?.data || { message: "error" });
    }
  }
);

export const giftWallet = createAsyncThunk(
  "wallet/giftWallet",
  async (args, thunkApi) => {
    try {
      const { data } = await axios.post(`${apiUri}/wallet/gift`, args, {
        headers: {
          "auth-token": "Bearer " + thunkApi.getState().auth.accessToken,
          "Accept-Language": document.documentElement.lang,
        },
      });
      return thunkApi.fulfillWithValue(data);
    } catch (e) {
      return thunkApi.rejectWithValue(e.response?.data || { message: "error" });
    }
  }
);

const newWalletSlice = createSlice({
  name: "newWallet",
  initialState,
  extraReducers: (b) => {
    b.addCase(getWallet.pending, (s) => {
      s.isLoading = true;
      s.error = null;
    })
      .addCase(getWallet.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.error = null;
        state.data = payload?.data?.data || [];
        state.itemsCount = Number(payload?.data?.itemsCount) || 0;
        state.pages = Number(payload?.data?.pages) || 0;
      })
      .addCase(getWallet.rejected, (s, { payload }) => {
        s.isLoading = false;
        s.error = payload?.message;
      })

      .addCase(giftWallet.pending, (s) => {
        s.isLoading = true;
        s.error = null;
      })
      .addCase(giftWallet.fulfilled, (s) => {
        s.isLoading = false;
      })
      .addCase(giftWallet.rejected, (s, { payload }) => {
        s.isLoading = false;
        s.error = payload?.message;
      });
  },
});

export default newWalletSlice.reducer;
